import { AddBlock } from '@/components/blocks/AddBlock';
import { InputBlock } from '@/components/blocks/InputBlock';
import classes from '@/components/pages/home/Page.module.scss';

export const Page = () => (
  <div className={classes.main}>
    <InputBlock />
    <AddBlock />
  </div>
);
